<template class="scroll-disable">
  <v-layout row justify-center>
    <v-dialog v-model="openDialog" width="300px" :fullscreen="!isLoading" hide-overlay transition="dialog-bottom-transition">
      <v-card color="primary" v-if="isLoading">
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="black" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
      <v-card  v-else-if="!isLoading">
        <v-toolbar dark color="black">
          <v-btn icon dark @click="closeDiaglog">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <h1>Customer Detail</h1>
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-list three-line subheader>
          <v-layout>
            <v-flex xs12 style="padding:20px;">
              <v-card>
                <v-card-title>
                  <v-icon color="black" medium>person</v-icon>
                  <h2 style="margin-left:5px;">Detail</h2>
                  <hr />
                </v-card-title>
                <hr />
                <v-card-text style="padding:19px">
                  <v-layout wrap>
                    <v-flex xs6>
                      <p>
                        <v-text-field
                          :value="eachCustomer.user_first_name"
                          label="Firstname"
                          outline
                          readonly
                          prepend-inner-icon="content_paste"
                        ></v-text-field>
                      </p>
                    </v-flex>
                    <v-flex xs6 style="padding-left:10px">
                      <p>
                        <v-text-field
                          :value="eachCustomer.user_last_name"
                          label="Lastname"
                          outline
                          readonly
                          prepend-inner-icon="content_paste"
                        ></v-text-field>
                      </p>
                    </v-flex>
                    <v-flex xs6>
                      <p>
                        <v-text-field
                          :value="eachCustomer.user_email"
                          label="Email"
                          outline
                          readonly
                          prepend-inner-icon="mail_outline"
                        ></v-text-field>
                      </p>
                    </v-flex>
                    <v-flex xs6 style="padding-left:10px">
                      <p>
                        <v-text-field
                          :value="eachCustomer.user_country_tel+eachCustomer.user_tel"
                          label="Tel"
                          outline
                          readonly
                          prepend-inner-icon="phone"
                        ></v-text-field>
                      </p>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-list>
        <v-divider></v-divider>
        <v-list three-line subheader style="padding:20px">
          <v-layout rows>
            <v-flex style="margin-top:10px;" xs6>
              <point
                :pointManageData="pointManageData"
                :eachCustomer="eachCustomer"
                @fetchPointList="fetchPointList"
              ></point>
            </v-flex>
            <v-flex style="margin-top:10px; margin-left:10px;" xs6>
              <point-exchange
                :pointManageData="pointManageData"
                :eachCustomer="eachCustomer"
                @fetchPointList="fetchPointList"
              ></point-exchange>
            </v-flex>
          </v-layout>
        </v-list>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import Point from "@/components/back-office/PointManage/Point";
import PointExchange from "@/components/back-office/PointManage/PointExchange";
export default {
  props: ["eachCustomer", "openDialog", "isLoading","pointManageData"],
  components: {
    "point": Point,
    "point-exchange": PointExchange
  },
  methods: {
    closeDiaglog() {
      this.$emit("closeDiaglog", this.openDialog);
    },
    fetchPointList(data) {
      this.$emit("fetchPointList", data);
    }
  }
};
</script>
<style scoped>
</style>
